module.exports = __webpack_public_path__ + "img/numTwo.2a525c6c.png";